import { createActions } from 'redux-actions';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../../common";
import { QUIZ_ATTEMPTS_API_ENDPOINT } from '../endpoints';
import { updateResourceState } from '../util';

const actions = createActions({
  ATTEMPTS: {
    API: {
      ADD: apiResourceActionCreator('attempts')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(QUIZ_ATTEMPTS_API_ENDPOINT, authToken, payload, actions.attempts.api.add)

const configuration = {
  name: 'add',
  action: actions,
  sagas: undefined,
  reducers: {
    request: (state, action) => updateResourceState(state, 'attempts', ({
      isFetching: true
    })),
    success: (state, action) => ({
      ...updateResourceState(state, 'attempts', ({
        isFetching: false,
        error: null
      }))
    }),
    failed: (state, action) => updateResourceState(state, 'attempts', ({
      isFetching: false,
      error: action.payload.error
    }))
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/quiz/configurations/attempts/add.js